import axios from '../localAxios';
import { getRoomShareCodeURL } from './roomsURLs';

type Room = {
  id: number;
  url: string;
  name: string;
};

type GetRoomShareUrlResponse = {
  message: 'Success';
  data: Room;
};

export type RoomDetail = {
  id: number;
  name: string;
  url: string;
};

export async function getRoomShareUrl(roomId: number): Promise<RoomDetail> {
  const url = getRoomShareCodeURL(roomId);
  const { data } = await axios.get<GetRoomShareUrlResponse>(url.href);
  return { ...data.data, id: roomId };
}
